// extracted by mini-css-extract-plugin
export var checkMarkContainer = "CheckBox-module--checkMarkContainer--HnYWv";
export var checkMarkContainerBlue = "CheckBox-module--checkMarkContainerBlue--mTbAU";
export var checkMarkContainerBlueChecked = "CheckBox-module--checkMarkContainerBlueChecked--1wQd1";
export var checkStyle = "CheckBox-module--checkStyle--1RMrM";
export var unChecked = "CheckBox-module--unChecked--3uVYM";